'use strict';

require('bootstrap-datepicker/dist/js/bootstrap-datepicker.js');
